import { memo } from "react";

import { QuestionMainKeyVisual } from "@/components/features/items/edit/_shared/ui/components/main/questions/key-visual/main-key-visual/index";

import { useRoomKeyVisual } from "./use-key-visual/use-key-visual";

type Props = {
	ownerID: string;
	resourceID: string;
};

export const QuestionDummyRoomKeyVisual = memo(({ ownerID, resourceID }: Props) => {
	const { mainKeyVisual, errorMessageMainKV, isEditedMainKV, onSetMainKeyVisual } = useRoomKeyVisual();

	return (
		<QuestionMainKeyVisual
			ownerID={ownerID}
			resourceID={resourceID}
			mainKeyVisual={mainKeyVisual}
			onSetMainKeyVisual={onSetMainKeyVisual}
			errorMessage={errorMessageMainKV}
			isEdited={isEditedMainKV}
		/>
	);
});

QuestionDummyRoomKeyVisual.displayName = "QuestionDummyRoomKeyVisual";
